import { Toolbox } from '~/plugins/toolbox/shared'
import { ProviderClient } from '../../providers/abstract/provider.client'
import { ProviderAiClient } from '../../providers/ai/client'
import { ProviderAsanaClient } from '../../providers/asana/.client'
import { ProviderAyrshareClient } from '../../providers/ayrshare/.client'
import { ProviderCronClient } from '../../providers/cron/client'
import { ProviderUIChatClient } from '../../providers/deprecated/ui-chat/client'
import { ProviderDiscordClient } from '../../providers/discord/.client'
import { ProviderDriveFileClient } from '../../providers/driveFile/client'
import { ProviderFirecrawlClient } from '../../providers/firecrawl/.client'
import { ProviderGmailClient } from '../../providers/gmail/.client'
import { ProviderGoogleCalendarClient } from '../../providers/google-calendar/.client'
import { ProviderGoogleDocClient } from '../../providers/google-doc/.client'
import { ProviderGoogleDriveClient } from '../../providers/google-drive/.client'
import { ProviderGoogleSheetClient } from '../../providers/google-sheet/.client'
import { ProviderHTTPClient } from '../../providers/http/.client'
import { ProviderIndexerClient } from '../../providers/indexer/client'
import { ProviderIntercomClient } from '../../providers/intercom/.client'
import { ProviderNotionClient } from '../../providers/notion/.client'
import { ProviderNylasClient } from '../../providers/nylas/.client'
import { ProviderOneDriveClient } from '../../providers/oneDrive/.client'
import { ProviderOutlookCalendarClient } from '../../providers/outlookCalendar/.client'
import { ProviderOutlookMailClient } from '../../providers/outlookMail/.client'
import { ProviderPostClient } from '../../providers/post/client'
import { ProviderAppSessionClient } from '../../providers/session/.client'
import { ProviderSlackClient } from '../../providers/slack/.client'
import { ProviderSqlClient } from '../../providers/sql/.client'
import { ProviderTaskClient } from '../../providers/task/client'
import { ProviderUIChatClientV2 } from '../../providers/ui-chatV2/client'
import { ProviderWordpressClient } from '../../providers/wordpress/.client'
import { ProviderXeroClient } from '../../providers/xero/.client'

export const useProviders = () => {
  const items = [
    ProviderGmailClient,
    ProviderGoogleDocClient,
    ProviderGoogleSheetClient,
    ProviderGoogleCalendarClient,
    ProviderGoogleDriveClient,
    ProviderOneDriveClient,
    ProviderAsanaClient,
    ProviderIntercomClient,
    ProviderSlackClient,
    ProviderDriveFileClient,
    ProviderGoogleSheetClient,
    ProviderIntercomClient,
    ProviderHTTPClient,
    ProviderAppSessionClient,
    ProviderSqlClient,
    ProviderDiscordClient,
    ProviderFirecrawlClient,
    ProviderUIChatClient,
    ProviderUIChatClientV2,
    ProviderTaskClient,
    ProviderIndexerClient,
    ProviderAiClient,
    ProviderCronClient,
    ProviderXeroClient,
    ProviderOutlookMailClient,
    ProviderOutlookCalendarClient,
    ProviderNotionClient,
    ProviderAyrshareClient,
    ProviderPostClient,
    ProviderWordpressClient,
    ProviderNylasClient,
  ]

  return Toolbox.UtilityItems.arrayToObject(items, item => item.key) as Record<
    string,
    ProviderClient
  >
}
